import { Injectable } from '@angular/core';
import { Adal4Service, Adal4HTTPService } from 'adal-angular4';
import { ToasterConfig } from 'angular2-toaster';
import { ModeratedPost } from './socialboard/models/post.model';
import { ActivityPostService } from '../home/socialboard/services/socialboard.service';

@Injectable()
export class HomeService {
    showSearchResults = false;
    searchTerm: string;
    searchResults: ModeratedPost[];
    isSearchResultsLoading = false;
    clearPostToolsForSearch = false;
    selectedPostId: string;

    constructor(
        private adalService: Adal4Service,
        private authHttp: Adal4HTTPService,
        private activityPostService: ActivityPostService
    ) { }

    toasterconfig: ToasterConfig = new ToasterConfig({
        showCloseButton: true,
        tapToDismiss: true,
        positionClass: 'toast-bottom-right'
    });

    checkForExpiredToken(): void {
        const $this = this;
        window.setInterval(function() {
            const now = new Date();
            const tokenTime = new Date($this.adalService.userInfo.profile.exp * 1000);
            if (tokenTime <= now) {
                // alert('Sigining Out');
                $this.adalService.logOut();
            }
            // else {
            //     console.log('== Now == ' + now);
            //     console.log('== Token == ' + tokenTime);
            // }
          }, 1000);
    }


    getSearchResults(keyWord?: string): void {
        if (keyWord) {
            keyWord = '&keywordSearch=' + keyWord;
        }

        this.activityPostService.getActivityPostFromApi(keyWord)
                               .subscribe(act  => { this.searchResults = act; },
                                          error => {
                                              console.log(' == Error == ' + error);
                                          },
                                            () => {
                                                this.isSearchResultsLoading = false;
                                                this.clearPostToolsForSearch = false;
                                                // console.log('== Setting isLoading == ' + this.isLoading);
                                            });
    }

    moreSearchResultPosts() {
        this.activityPostService.updateBaseUrl(this.activityPostService.pagination.nextPageLink);
        const url = this.activityPostService.returnBaseUrl();
        console.log('== updated url == ' + url);
        if (url.indexOf('keywordSearch') !== -1) {
            this.getSearchResults('');
        } else {
            this.getSearchResults(this.searchTerm);
        }

    }

}



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/routes/home/home.service.ts